import angular from 'angular'

import FeedbackComponent from './vd-feedback.component'
import FeedbackService from './vd-feedback.service'

angular
  .module('vend.ui')
  .component('vdFeedback', FeedbackComponent)
  .service('vdFeedbackService', FeedbackService)
